import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  inject,
  AfterViewInit,
  DOCUMENT,
} from '@angular/core';
import { faTimes } from '@fortawesome/pro-regular-svg-icons';
import { v4 as uuid } from 'uuid';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
  standalone: true,
  imports: [FormsModule, FaIconComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ModalComponent implements AfterViewInit {
  private document = inject<Document>(DOCUMENT);
  private cdr = inject(ChangeDetectorRef);

  faTimes = faTimes;

  id = uuid();
  @Input() loading = false;
  @Input() allowHide = true;
  @Input() wide = false;

  @Input() isOpen = false;
  @Input() allowClose = true;
  @Input() overflowVisible = false;

  @Output() dismissed = new EventEmitter<void>();

  showContent = false;
  showModal = false;

  ngAfterViewInit(): void {
    if (this.isOpen) {
      console.log('open');
      this.show();
    }
  }

  show() {
    this.showContent = true;
    // const myDialog: HTMLDialogElement | null = this.document.querySelector(
    //   `#modal-${this.id}`
    // );
    // myDialog?.showModal();
    this.showModal = true;
    this.cdr.detectChanges();
  }

  hide() {
    if (this.allowClose) {
      this.showContent = false;
      this.dismissed.emit();
      // const myDialog: HTMLDialogElement | null = this.document.querySelector(
      //   `#modal-${this.id}`
      // );
      // myDialog?.close();
      this.showModal = false;
      this.cdr.detectChanges();
    }
  }
}
